import React, { useRef, useEffect, useState } from 'react';
import { loginUser, isValidate } from '../components/services/api';
import logo from '../assets/Light Logo.png';
import { SlEnvolope } from 'react-icons/sl';
import { useNavigate } from 'react-router-dom';
import { GoLock } from 'react-icons/go';
import ScreenLoading from '../components/ScreenLoading';

export default function LoginComp() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const ranOnce = useRef(false);
    useEffect(() => {
        if(ranOnce.current) return;
        ranOnce.current = true;
        const checkValidation = async () => {
            // const sckietman = localStorage.getItem("sckietman");
            // if (!sckietman) return;
            try {
                setLoading(true);
                const result = await isValidate();
                if (result?.d === true) {
                    navigate('/event-news', { replace: true });
                }
                else {
                    navigate('/');
                    setLoading(false);
                }
            }
            catch (error) {
                navigate('/');
                setLoading(false);
            }
        };
        checkValidation();
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await loginUser(email, password);

            if (response.status === 200) {
                //document.cookie = `${response.CookieName}=${response.CookieValue}; expires=${response.Expiry}; path=/;`
                // localStorage.setItem(response.CookieName, response.CookieValue);
                //setMessage("Login Successful");
                // const validateResponse = await isValidate();
                // if (validateResponse.d == true) {
                navigate('/event-news', {replace: true});
                // setLoading(false);
                // }
                // else if(validateResponse.d == false){
                //     navigate("/subscription");
                // }
            }
            else if (response.status === 400) {
                console.log("User is defaulter. Cannot set cookie.");
                navigate('/subscription');
                setLoading(false);
            }
            else {
                setMessage('Invalid Credentials')
                setLoading(false);

            }
        } catch (error) {
            setMessage("Login Failed");
            setLoading(false);

        }
    };

    if (loading) {
        return (
            <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
                <ScreenLoading />
            </div>
        );
    }
    return (
        <div className='container-fluid login-bg-img' >
            <div className='container'>
                <div className="row text-center align-items-center" style={{ height: '100vh' }}>
                    <div>
                        <img src={logo} alt="loading" width="220px" className='pb-3' />
                        {/* <h3 className='sub-heading m-2 font-weight-bold'>Login Your Account</h3> */}
                        <h1 className='main-heading'>Login</h1>

                        <div className="col-sm-5 mx-auto p-3 rounded-4 login-box ">
                            <div className='py-5 px-3 rounded-4'>
                                <h3>Welcome Back!</h3>
                                <h6 className='sub-heading m-2'>Login Your Account</h6>
                                <form className='p-4' onSubmit={handleLogin}>
                                    <div className="input-group mb-3">
                                        <span className='input-group-text'><SlEnvolope /></span>
                                        <input type="email" className="form-control my-input" placeholder='Enter your email' value={email} onChange={e => setEmail(e.target.value)} id="Inputemail" aria-describedby="emailHelp" required />
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <span className="input-group-text"><GoLock  /></span>
                                        <input type="password" className="form-control my-input" placeholder='Enter your password' value={password} onChange={e => setPassword(e.target.value)} id="password" required />
                                    </div>
                                    {/* <div className="mb-3 form-check text-start">
                                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                        <label className="form-check-label" for="exampleCheck1">Remember Me</label>
                                    </div> */}

                                    <button type="submit" className="btn btn-custom login-btn d-grid col-12">Login</button>
                                    {/*d-grid*/}
                                    <div className="pt-2" style={{ color: "red" }}>{message}</div>
                                </form>
                                {/* <div className='text-center signup-link'>
                                    <p className=''>New to TicketsInfo?</p>
                                    <span onClick={() => navigate('/signup')} style={{ cursor: 'pointer' }}>Signup for a new account</span>
                                </div> */}

                                <span className='text-center copy-right'>© 2026 TicketsInfo.NET Drop Checker All Right Reserved.</span>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
